/* import __COLOCATED_TEMPLATE__ from './tab-signal-chart.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();